<template>
  <div
    id="app"
    tabindex="0"
    @keydown.j="(targetPromptShowing && emitResponse(false))"
    @keydown.k="emitResponse(true)"
    @keydown.space="showTargetPrompt()"
  >

    <div v-if="studyMode == 'reviewing'" class="badge badge--blue">
      Reviewing
    </div>
    <div v-if="studyMode == 'learning'" class="badge badge--green">
      Learning New Items
    </div>

    <div v-if="currentIndex === null">
      <div v-if="studyMode == 'learning'">
        We're done studying!
      </div>
      <div v-else>
        Done reviewing.
        <button v-on:click="startNewItemSession">
          Move on to New Items
        </button>
      </div>
    </div>

    <div v-else-if="studyMode === null">
      <div>
        <span style="color: #6abaec">{{ itemsReadyForReview.length }}</span>
        items ready for review
      </div>
      <button v-on:click="startReviewItemSession">
        Start Review
      </button>
    </div>

    <div class="card-container" v-else>
      <div class="card-display" v-if="!targetPromptShowing">
        <ItemDisplay v-bind:item="currentItem" v-bind:showing="cues"></ItemDisplay>
        <div class="button-container">
          <button v-on:click="showTargetPrompt">Respond</button>
        </div>
        <!-- <textarea id="test-text-area" v-swallow-hotkeys></textarea> -->
      </div>
      <component
        v-if="targetPromptShowing"
        v-bind:item="currentItem"
        v-bind:showing="targetProperties"
        v-bind:is="targetHandlerComponent"
      ></component>
    </div>
  </div>
</template>

<style lang="scss">
.badge {
  background: gray;
  color: white;
  border-radius: 6px;
  display: inline-block;
  padding: 2px 16px;
}

.badge--blue {
  background: rgb(71, 209, 255);
}

.badge--green {
  background: rgb(56, 224, 56);
}

.item-display {
  padding-top: 50px;
  padding-bottom: 50px;
}
</style>

<script>

/* eslint no-console: off */

function swallowHotkeys(element) {
  element.addEventListener("keydown", function(event) {
    event.stopPropagation();
  });
}

function resetFocus() {
  document.getElementById("app").focus();
}

window.addEventListener('load', function() {
  document.getElementById('app').onblur = refocus;
})

function refocus(e) {
  if (e.relatedTarget && e.relatedTarget.nodeName != "TEXTAREA") {
    resetFocus();
  }
}

// function getMinIndices(obj) {
//   var lowestIndices = [];
//   var lowestValue = Infinity;
//   for (let index of Object.keys(obj)) {
//     var score = obj[index];
//     if (score < lowestValue) {
//       lowestValue = score;
//       lowestIndices = [index];
//     } else if (score == lowestValue) {
//       lowestIndices.push(index);
//     }
//   }
//   return lowestIndices;
// }

import Vue from 'vue';

Vue.config.devtools = true;
Vue.config.keyCodes.h = 72;
Vue.config.keyCodes.j = 74;
Vue.config.keyCodes.k = 75;
Vue.config.keyCodes.l = 76;

Vue.directive("swallow-hotkeys", {
  inserted: function(element) {
    // swallowHotkeys(element);

    // element.addEventListener("keydown", function(event) {
    //   var KEY_ESCAPE = 27;
    //   if (event.keyCode == KEY_ESCAPE) {
    //     resetFocus();
    //   }
    // });
  }
});

function logResponse(response) {
  // var history = localStorage.getItem("response-history");
  // if (history !== null) {
  //   history = JSON.parse(history);
  // }
  // else {
  //   history = [];
  // }

  // history.push(response);
  // localStorage.setItem("response-history", JSON.stringify(history));

  response;
}

var scheduler;

import SelfCheckTarget from '@/components/SelfCheckTarget.vue';
import ItemDisplay from '@/components/ItemDisplay.vue';
import EventBus from '@/libs/EventBus.js';
import Scheduler from '@/libs/ShortTermScheduler.js';
import StudyItem from '@/libs/StudyItem.js';

// import * as DB from '@/js/db.js';

// import * as Pool from '@/js/ItemPool.js';

// import { ajax } from '@/js/util.js';

import { mapGetters } from 'vuex';

import * as db from '@/libs/db.js';

window.addEventListener("load", function() {
  resetFocus();
});

export default {
  data: function() {
    return {
      items: [],
      target: "",
      cues: [],
      targetProperties: [],
      session: "",
      sessionGroup: "",
      studyMode: null,
      currentIndex: 0,
      targetPromptShowing: false,
      // targetHandlerComponent: "self-check-target"
      // targetHandlerComponent: "SelfCheckTarget"
      targetHandlerComponent: SelfCheckTarget,
      // pool: Pool.pool,
      // newItems: Pool.newItems,
    };
  },
  store: db.store,
  components: {
    ItemDisplay,
  },
  computed: {
    currentItem: function() {
      console.log("current index:", this.currentIndex, "items:", this.items);
      if (this.items.length == 0 || this.currentIndex === null) {
        return [];
      }
      return this.items[this.currentIndex];
    },
    ...mapGetters(['newItems', 'reviewItems', 'itemsReadyForReview']),
  },
  methods: {
    emitResponse: function(bool) {
      EventBus.$emit("response-event", bool);
    },
    logResponse: function(response) {
      response["session"] = this.session;
      response["sessionGroup"] = this.sessionGroup;

      // var uri = buildGetRequestUri("/log-response", response);

      logResponse(response);

      // ajax(uri, data => {
      //   console.log("server:", data);
      // });
    },
    handleResponse: async function(success) {
      this.logResponse({
        time: new Date().getTime(),
        // itemId: this.currentIndex,
        itemId: this.items[this.currentIndex].id,
        type: "response",
        promptType: this.cues.join("+") + `=>${this.target}`,
        success
      });

      scheduler.addResponse({
        // itemId: this.currentIndex,
        itemId: this.items[this.currentIndex].id,
        success,
      });

      this.targetPromptShowing = false;
      await this.showNextItem();
    },
    findProperty: function(item, key) {
      for (let prop of item.properties) {
        if (prop.key == key) {
          return prop;
        }
      }
      return null;
    },
    showTargetPrompt: function() {
      this.targetPromptShowing = true;
      this.targetProperties = ["english", "note", "thai"];
      // var thai = this.findProperty(this.items[this.currentIndex], "thai").value;

      let thai = this.items[this.currentIndex].properties.thai.value;
      thai = thai.split("-").map(word => word.trim()).join("")

      sayText(thai, 1, 26, 3);
    },
    showNextItem: async function() {
      this.rotatePropertyValues(this.currentItem);
      this.currentIndex = scheduler.getNextItemIndex();

      if (this.currentIndex === null) {
        await this.finishStudySession();
      }

      // this.currentIndex = (this.currentIndex + 1) % this.items.length;
    },
    finishStudySession: async function() {
      var results = scheduler.getStudySessionResults();

      console.log("ITEMS:", this.items);
      console.log("STORE:", this.$store);
      
      for (let result of Object.values(results)) {
        console.log("RESULT:", result);
        var historyEntry = {
          date: (new Date()).getTime(),
          score: result.score,
        };

        // if (Pool.pool[result.itemId] !== undefined) {
        //   Pool.pool[result.itemId].history.push(historyEntry);
        // }

        // let poolItem = await Pool.getPoolItem(result.itemId);

        let poolItem = this.$store.getters.itemsById[result.itemId];
        poolItem.studying = true;
        if (poolItem !== undefined) {
          if (poolItem.history === undefined) {
            poolItem.history = [];
          }

          await this.$store.dispatch('addHistoryItem', {
            item: poolItem,
            historyEntry,
          });

          // need to save the `studying = true` property
          await this.$store.dispatch('putItem', poolItem);
        }
        else {
          window.alert(`Not supposed to reach this code!`);

          // first study

          // poolItem.history = [ historyEntry ];
          // await this.$store.dispatch('putItem', poolItem);
        }
      }

      // console.log("POOL:", Pool.pool);
      // Pool.savePool();
      // Pool.saveNewItems();
    },
    findItemById(itemId) {
      for (let item of this.items) {
        if (item.id === itemId) {
          return item;
        }
      }
      return null;
    },
    shuffleRotatedPropertyValues: function() {
      for (let item of this.items) {
        for (let propertyName of Object.keys(item.properties)) {
          let property = item.properties[propertyName];
          if (property.rotate) {
            let index = Math.floor(Math.random() * property.value.length);
            item.properties[propertyName].current = index;
          }
        }
      }
    },
    rotatePropertyValues: function(item) {
      for (let propertyName of Object.keys(item.properties)) {
        let property = item.properties[propertyName];
        if (property.rotate) {
          let nextIndex = (property.current + 1) % property.value.length;
          item.properties[propertyName].current = nextIndex;
        }
      }
    },
    async startNewItemSession() {
      this.studyMode = "learning";

      var queue = await this.$store.getters.newItemCandidates;
      console.log("new item candidates:", queue);

      var studySetSize = 5;
      if (queue.length < studySetSize) {
        throw Error(`Can't study with only ${queue.length} items. Must have at least ${studySetSize} new items available.`);
      }

      var studySet = [];
      for (var i=0; i<studySetSize; i++) {
        // var item = queue.pop();
        var item = queue[i];
        // item.id = getNewId();
        studySet.push(item);
      }

      // XXX was this needed in the first place?
      // Pool.saveNewItems();

      this.loadStudySet(studySet, "thai", ["english", "note"]);
    },

    async startReviewItemSession() {
      this.studyMode = "reviewing";

      var studySet = [];

      // let reviewItems = await Pool.getReviewItems();
      let reviewItems = this.reviewItems;
      console.log("REVIEW ITEMS:", reviewItems);

      for (let item of Object.values(reviewItems)) {
        // if (!item.disabled && itemReadyToReview(item)) {
        if (!item.disabled && item.itemReadyToReview()) {
          studySet.push(item);

          // XXX
          if (studySet.length >= 10) {
            console.log("Maxed out review session.");
            break;
          }
          // XXX
        }
      }

      if (studySet.length < 4) {
        console.error(`Study set only has ${studySet.length} items, which isn't enough to review.`);
        this.currentIndex = null;
        return;
      }

      this.loadStudySet(studySet, "thai", ["english", "note"]);
      // EventBus.$on("response-event", this.handleResponse);
    },
    loadStudySet(items, target, cues) {
      var self = this;

      this.session = new Date().getTime();
      // this.sessionGroup = url.replace(/\//g, "");

      scheduler = new Scheduler();
      scheduler.studyMode = this.studyMode.toString();
      scheduler.setItems(items);

      // self.items = items.map(function(item) {
      //   return new StudyItem(item, target);
      // });
      self.items = items;
      this.cues = cues;
      this.target = target;

      this.currentIndex = scheduler.getNextItemIndex();
      self.shuffleRotatedPropertyValues();
    },
  },
  mounted: function() {
    EventBus.$on("response-event", this.handleResponse);
  },
  destroyed: function() {
    EventBus.$off("response-event");
  },
};
</script>

